import React, { FC } from 'react';
import { Modal as DefaultModal } from '@material-ui/core';
import { ModalContent, Button, CloseIcon, Backdrop } from './styles';
import { Props } from './types';

const Modal: FC<Props> = ({
  open,
  showClose = true,
  handleClose,
  children,
  ...props
}) => {
  return (
    // @ts-ignore
    <DefaultModal
      aria-labelledby="spring-modal-title"
      aria-describedby="spring-modal-description"
      open={open}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      disableEnforceFocus
      {...props}
    >
      <ModalContent className="modal-ui">
        {showClose ? (
          <Button type="button" onClick={handleClose}>
            <CloseIcon />
          </Button>
        ) : null}
        {children}
      </ModalContent>
    </DefaultModal>
  );
};

export default Modal;
